import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function LandingPage() {
  const navigate = useNavigate();

  return (
    <div style={{ minHeight: '100vh', background: '#0D0D1A' }}>
      
      {/* Navbar */}
      <nav style={{
        display: 'flex', justifyContent: 'space-between', alignItems: 'center',
        padding: '20px 60px', borderBottom: '1px solid #2A2A4A'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <img src="/app_icon.png" alt="ApplyEdge" style={{ width: 36, height: 36, borderRadius: 10 }} />
          <span style={{ fontFamily: 'Space Grotesk, sans-serif', fontWeight: 700, fontSize: 20, color: '#fff' }}>ApplyEdge</span>
        </div>
        <button onClick={() => navigate('/app')} style={{
          background: 'linear-gradient(135deg, #0F7DFF, #00D4AA)',
          border: 'none', borderRadius: 10, padding: '10px 24px',
          color: '#fff', fontFamily: 'Inter, sans-serif', fontWeight: 600,
          fontSize: 14, cursor: 'pointer'
        }}>Get Started</button>
      </nav>

      {/* Hero */}
      <div style={{ textAlign: 'center', padding: '80px 20px 60px' }}>
        <div style={{
          display: 'inline-block', background: '#1A1A2E', border: '1px solid #2A2A4A',
          borderRadius: 20, padding: '6px 16px', marginBottom: 24
        }}>
          <span style={{ color: '#00D4AA', fontSize: 13, fontWeight: 500 }}>⚡ AI-Powered CV Optimisation</span>
        </div>
        <h1 style={{
          fontFamily: 'Space Grotesk, sans-serif', fontSize: 56, fontWeight: 700,
          lineHeight: 1.15, marginBottom: 20, letterSpacing: '-1px'
        }}>
          Tailor your CV to<br />
          <span style={{ background: 'linear-gradient(135deg, #0F7DFF, #00D4AA)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
            every job in seconds
          </span>
        </h1>
        <p style={{ color: '#8888AA', fontSize: 18, maxWidth: 560, margin: '0 auto 40px', lineHeight: 1.6 }}>
          Upload your CV and paste a job description. ApplyEdge rewrites your CV for that specific role with ATS-focused improvements.
        </p>
        <button onClick={() => navigate('/app')} style={{
          background: 'linear-gradient(135deg, #0F7DFF, #00D4AA)',
          border: 'none', borderRadius: 14, padding: '16px 40px',
          color: '#fff', fontFamily: 'Inter, sans-serif', fontWeight: 600,
          fontSize: 16, cursor: 'pointer', boxShadow: '0 8px 32px rgba(15,125,255,0.35)'
        }}>Optimise My CV →</button>

        {/* Play Store Badge */}
        <div style={{ marginTop: 20, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 12 }}>
          <span style={{ color: '#555570', fontSize: 13 }}>Also available on</span>
          <a href="https://play.google.com/store/apps/details?id=com.applyedge.apply_edge" target="_blank" rel="noreferrer">
            <img src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png" alt="Get it on Google Play" style={{ height: 40 }} />
          </a>
        </div>
      </div>

      {/* Features */}
      <div style={{ display: 'flex', justifyContent: 'center', gap: 20, flexWrap: 'wrap', padding: '0 40px 80px' }}>
        {[
          { icon: '📊', title: 'ATS Score', desc: 'See your match score before and after optimisation' },
          { icon: '✨', title: 'AI Tailored CV', desc: 'Rewritten to match the exact job you\'re applying for' },
          { icon: '✉️', title: 'Cover Letter', desc: 'Professional, personalised, non-generic' },
          { icon: '💡', title: 'Interview Tips', desc: '3 key talking points based on the specific job' },
          { icon: '📈', title: 'Insights', desc: 'ATS analysis, what improved and what to work on next' },
        ].map((f, i) => (
          <div key={i} style={{
            background: '#1A1A2E', border: '1px solid #2A2A4A', borderRadius: 16,
            padding: '24px', width: 200, textAlign: 'center'
          }}>
            <div style={{ fontSize: 32, marginBottom: 12 }}>{f.icon}</div>
            <div style={{ fontFamily: 'Space Grotesk, sans-serif', fontWeight: 600, marginBottom: 8 }}>{f.title}</div>
            <div style={{ color: '#8888AA', fontSize: 13, lineHeight: 1.5 }}>{f.desc}</div>
          </div>
        ))}
      </div>

      {/* Footer */}
      <div style={{ textAlign: 'center', padding: '20px', borderTop: '1px solid #2A2A4A', color: '#555570', fontSize: 13 }}>
        © 2026 ApplyEdge · theapplyedge.com
      </div>

    </div>
  );
}